
export const ApprovalRequestTodoCountChangedKey = 'approval-request-todo-count-changed';
export function subscribeApprovalRequestTodoCountChanged(func) {
  document.addEventListener(ApprovalRequestTodoCountChangedKey as any, func);
}
export function dispatchApprovalRequestTodoCountChanged(params = {}) {
  document.dispatchEvent(new CustomEvent(ApprovalRequestTodoCountChangedKey, params));
}
